import { FIND_RESULT_RATINGS_REQUEST, findResultRatingsSuccess, findResultRatingsFailure} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export function findResultRatingsEpic(action$, store$, { ResultRatingRepository }) {
    return action$.pipe(
        ofType( FIND_RESULT_RATINGS_REQUEST ),
        mergeMap(action => from(
            ResultRatingRepository.findAll(action.payload)
                .then(({ resultRatings, meta }) => findResultRatingsSuccess({ resultRatings, response: meta, request: action}))
                .catch(error => findResultRatingsFailure({ error, request: action })),
        )),
    );
}
